import { config } from '@num/config'

export default {
  data() {
    return {
      boxList: Array.from(new Array(config.ORDERBOXES), (el, i) => ({ status: "empty", box: i + 1 })),
    };
  },
  computed: {
    boxColumns() {
      return config.ORDERBOX_COLUMNS;
    },
    newOrderList() {
      return this.$root.$data.orderList.filterByAttr("status", "new")
    },
    prepOrderList() {
      return this.$root.$data.orderList.list
        .filter(v => v.status == "in_production" || v.status.indexOf("in_prep_") == 0)
    },
    prepOnlyOrderList() {
      return this.$root.$data.orderList.filterByAttr("status", "in_production")
    },
    pastOrderList() {
      return this.$root.$data.orderList.filterByAttr("status", "done")
        .slice(-config.PASTORDERS_LIMIT)
    },
    pickupOrderList() {
      return this.$root.$data.orderList.list
        .filter(v => v.status.indexOf("in_box_") == 0)
    },
    pickupOrderBoxList() {
      //TODO: for cheesiness we align box and order, could be a problem in the future
      return this.boxList.map((box) => {
        let order = this.$root.$data.orderList.findByAttr("status", config.ORDER_STATUS_PICKUP_PREFIX + box.box)
        if (order) {
          return {
            ...box,
            number: order.number,
            id: order.id,
            status: order.status,
            order_label: order.order_label,
            pagernumber: order.pagernumber,
            trackernumber: order.trackernumber,
          }
        }
        return {
          ...box,
          number: null,
          id: null,
          status: "empty"
        }
      })
    },
    prepareOrderList() {
      //TODO: for cheesiness we align box and order, could be a problem in the future
      return this.boxList.map((box) => {
        let order = this.$root.$data.orderList.findByAttr("status", config.ORDER_STATUS_PREP_PREFIX + box.box)
        if (order) {
          return {
            ...box,
            number: order.number,
            id: order.id,
            status: order.status,
            order_label: order.order_label,
            pagernumber: order.pagernumber,
            trackernumber: order.trackernumber,
          }
        }
        return {
          ...box,
          number: null,
          id: null,
          status: "empty"
        }
      })
    }
  },
}
